module.exports = __webpack_public_path__ + "img/foove-GmbH-legal-logo.d457ac15.png";